import React, {
    useEffect,
} from "react";
import { ApiFactory } from "../../ApiClient";
import { Chord } from "../../model/core";
import { TonalityInputBox } from "../pickers/ContextTonality";
import { RydIntervalPatternInput } from "./data-input/RydIntervalPatternInput";
import {
    IntervalPattern,
    Tonality
} from "../../model/scales";
import { ScalesService } from "../../services/ScalesService";


const API = ApiFactory.create();

export function RydScaleSelector({
    scale,
    patternChangedCB,
}: {
    scale?: Tonality,
    patternChangedCB?: (pattern: IntervalPattern) => void;
}) {

    const [selectedScale, setSelectedScale] = React.useState<Tonality | undefined>(scale);
    const [selectableChords, setSelectableChords] = React.useState<Chord[]>([]);
    // Maintain local activeSteps so that checkboxes work even when no scale is selected.
    const [activeSteps, setActiveSteps] = React.useState<number[]>([0]);
    const [matchedPattern, setMatchedPattern] = React.useState<IntervalPattern | undefined>(undefined);

    useEffect(() => {
        const currentSteps = selectedScale
            ? selectedScale.scalePattern.pattern.toActiveSteps()
            : activeSteps;
        console.log("Current Steps: ", currentSteps);

        const knownPatterns = ScalesService.listPatterns();
        const _matchedPattern = knownPatterns.find(p => {
            const activeSteps = p.pattern.toActiveSteps();
            console.log("Pattern: ", p, activeSteps);
            return activeSteps.length === currentSteps.length &&
                activeSteps.every((step, idx) => step === currentSteps[idx]);
        });

        console.log("Matched Pattern: ", _matchedPattern);

        setMatchedPattern(_matchedPattern?.pattern);
        // FIXME: should allow for informing the parent event if it ins't a known pattern.
        if (_matchedPattern) patternChangedCB?.(_matchedPattern.pattern);

    }, [selectedScale, activeSteps, patternChangedCB]);

    // Render 12 checkboxes representing each pitch class (0-11)

    return (
        <div>
            <TonalityInputBox
                setTonalityCB={(tonality) => {
                    setMatchedPattern(tonality?.scalePattern.pattern);
                    setSelectedScale(tonality);
                    if (tonality) {
                        patternChangedCB?.(tonality.scalePattern.pattern);
                    }
                }}
                tonality={selectedScale}
            />

            <RydIntervalPatternInput
                selectedScale={selectedScale}
                activeSteps={activeSteps}
                setSelectedScale={setSelectedScale}
                setActiveSteps={setActiveSteps} />

            <div style={{ marginTop: "10px" }}>
                Matched: <strong>{matchedPattern?.name}</strong>
            </div>

            <ol>
                {selectableChords?.map((c: Chord, i) => <li key={i}>{c.getName()}</li>)}
            </ol>

        </div>
    );
}

